import { createFileRoute } from '@tanstack/react-router';

import { StudentPortalEntry } from '@/features/student-portal/StudentPortalEntry';

export const Route = createFileRoute('/student-portal/')({
  component: StudentPortalEntry,
});
